import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FaWallet } from 'react-icons/fa'
import AddBalance from './AddBalance';

const Wallet = () => {
    const { t } = useTranslation();
    const [addModalOpen, setAddModalOpen] = useState(false);
    return (
        <div>
            <div>
                <div className="bg-gradient-to-tr from-[#dfdfdf42] border  to-[#ffc99327] rounded-2xl p-5 w-full max-w-sm flex flex-col justify-between">
                    {/* Balance Info */}
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-gray-500 text-sm">{t("availableBalance")}</p>
                            <div className="flex items-end gap-1">
                                <span className="text-secondry font-bold text-2xl">{0.00}</span>
                                <span className="text-secondry font-semibold text-sm">LYD</span>
                            </div>
                        </div>
                        <FaWallet className="text-secondry text-xl" />
                    </div>
                    {/* Add Balance Button */}
                    <button
                    disabled
                        onClick={() => setAddModalOpen(true)}
                        className="mt-6 grayscale cursor-not-allowed bg-primary hover:bg-[#004e11] text-white py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-all"
                    >
                        <span className="text-lg">+</span>
                        {t("addBalance")}
                    </button>
                </div>
            </div>
            {addModalOpen && <AddBalance show={addModalOpen} setShow={setAddModalOpen} />}
        </div>
    )
}

export default Wallet